import React from "react";
import "../Footers/Footer.css";
import logo from "../../assets/images/logo-widetext.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import {
faFacebookF,
faYoutube,
faInstagram,
faWhatsapp,
faLinkedinIn
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {

const year = new Date().getFullYear();

return (

<footer className="foots">

<div className="footer-waves">
<div className="wave wave1"></div>
<div className="wave wave2"></div>
</div>

<div className="rows">

<div className="cols">

<img className="logoimg" src={logo} alt="school logo"/>

<p className="para">
North Point Children’s Academy is a leading co-educational English-medium school with day facilities, nurturing students from Play Group to Class XII in a holistic learning environment for more than 40 years.
</p>

<div className="socials">

<div className="social-icons facebook">
<a href="https://www.facebook.com/northpointdoon/" target="_blank" rel="noopener noreferrer"> 
<FontAwesomeIcon icon={faFacebookF}/>
</a>
</div>

<div className="social-icons youtube">
<a href="https://www.youtube.com/@northpointdehradun/" target="_blank" rel="noopener noreferrer">
<FontAwesomeIcon icon={faYoutube}/>
</a>
</div>

<div className="social-icons instagram">
<a href="https://www.instagram.com/northpointgarhicantt/" target="_blank" rel="noopener noreferrer">
<FontAwesomeIcon icon={faInstagram}/>
</a>
</div>

<div className="social-icons linkedin">
<a href="https://www.linkedin.com/in/northpoint-children-sacademy-0baa22405" target="_blank" rel="noopener noreferrer">
<FontAwesomeIcon icon={faLinkedinIn}/>
</a>
</div>

<div className="social-icons whatsapp">
<a href="https://wa.me/919456311713" target="_blank" rel="noopener noreferrer">
<FontAwesomeIcon icon={faWhatsapp}/>
</a>
</div>

</div>

</div>

<div className="cols">

<h3>Quick Links</h3>

<ul>

<li><Link to="/" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Home</Link></li>
<li><Link to="/activities" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Activities</Link></li>
<li><Link to="/curriculum" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Curriculum</Link></li>
<li><Link to="/contactus" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Contact Us</Link></li>
<li><Link to="/gallery" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Gallery</Link></li>

</ul>

<div className="adminbtn">

<Link to="/login">
<button className="adbtn">Click Here For Admin Panel</button>
</Link>

</div>

</div>

<div className="cols">

<h3>Useful Links</h3>

<ul>

<li><Link to="/facilities" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Facilities</Link></li>
<li><Link to="/regadmission" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Registration & Admission</Link></li>
<li><Link to="/fees" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Fees Structure</Link></li>
<li><Link to="/onlineregister" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Online Registration</Link></li>
<li><Link to="/downfilestype" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>Download Forms & Files</Link></li>

</ul>

</div>

<div className="colsadd">

<h3>Quick Contact</h3>

<p>+91-0135-3598009</p>
<p>+91-9837923036, +91-8273065299</p>

<p className="email-id">
    northpointdehradun@gmail.com
</p>

<p>
Add.: 50, Tapkeshwar Road, Garhi Cantt,
Dehradun, Uttarakhand - 248003
</p>

</div>

</div>

<hr/>

<p className="copyright">
Copyright © {year} North Point Children's Academy.
All Rights Reserved | Developed by Sunil Singh Rawat
</p>

</footer>

);
};

export default Footer;